// libraries.
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { apiVim } from "@store/apiSlices/apiSlices";

// interfaces.
import { ModelResult, VimParams } from "@domains/VIM/interfaces/interfaces";
import { ModelError } from "@store/apiSlices/interfaces/interfaces";

// slices.
export const inventoryVimInfo = apiVim.injectEndpoints({
  endpoints: (builder) => ({
    getVimInfo: builder.query({
      query: ({ country, nid }: VimParams) => {
        return `/get_vim_${country.toLowerCase()}?country=${country}&nid=${nid}`;
      },
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: "getVimInfo",
        };
        return modelError;
      },
      transformResponse: (response: ModelResult): ModelResult => {
        return response;
      },
    }),
  }),
});

export const { useGetVimInfoQuery } = inventoryVimInfo;
